<template>
  <div id="review-select-dialog">
    <ipub-model :title="'Invitation List'"
                width="500px"
                :visable="isVisable"
                confirmText="Choose"
                @confirm="confirm"
                @cancel="cancel">
      <div class="ipub-p4 font-color mar-b-12">
        You have 3 Reviewers in this search Research, please choose the one you want.
      </div>
      <template v-if="inputData">
        <div v-for="item in inputData.reviewSelect"
             :key="item.id"
             class="ipub-line-block ipub-p2 ipub-border mar-b-4">
          <ipub-row>
            <ipub-col :span="1">
              <ipub-radio @change="handleChange(item)"
                          :checked="select.id === item.id"></ipub-radio>
            </ipub-col>
            <ipub-col :span="4">
              {{item.firstName}} {{item.lastName}}
            </ipub-col>
            <ipub-col :span="7">
              {{item.email}}
            </ipub-col>
          </ipub-row>
        </div>
      </template>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    },
  },
  data () {
    return {
      select: []
    }
  },
  computed: {
    ...mapGetters({
      domain: 'getDomain',
      reviewRefuse: 'getReviewRefuse'
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.select = []
      }
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
    confirm () {
      this.$emit('confirm', this.select)
    },
    handleChange (val) {
      this.select = val
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
